import rose from '../assets/rose.png';
import tulip from '../assets/tulip.png';
import sunflower from '../assets/sunflower.png';
import orchid from '../assets/orchid.png';
import lily from '../assets/lily.jpg';
import daffodil from '../assets/daffodil.png';
import hydrangea from '../assets/hydrangea.jpg';
import peony from '../assets/peony.jpg';
import carnation from '../assets/carnation.jpg';
import chrysanthemum from '../assets/chrysanthemum.png';
import blue_orchid from '../assets/blue_orchid.png';
import lavender from '../assets/lavender.png';


const flowers = [
    {
        name: 'Rose',
        description: 'Often associated with love and romance, roses come in various colors, each symbolizing different sentiments.',
        price: 20.00,
        imageUrl: rose,
        quantity: 10
    },
    {
        name: 'Tulip',
        description: 'A symbol of perfect love, tulips are spring-blooming flowers that are available in many colors and varieties.',
        price: 15.00,
        imageUrl: tulip,
        quantity: 9
    },
    {
        name: 'Sunflower',
        description: 'Known for their large faces and bright yellow petals, sunflowers symbolize adoration, loyalty, and longevity.',
        price: 10.00,
        imageUrl: sunflower,
        quantity: 8
    },
    {
        name: 'Orchid',
        description: 'These exotic and elegant flowers are highly diverse and symbolize love, luxury, beauty, and strength.',
        price: 30.00,
        imageUrl: orchid,
        quantity: 8
    },
    {
        name: 'Lily',
        description: 'Often used in religious and cultural ceremonies, lilies symbolize purity and refined beauty.',
        price: 18.00,
        imageUrl: lily,
        quantity: 8
    },
    {
        name: 'Daffodil',
        description: 'A herald of spring, daffodils are associated with new beginnings, rebirth, and eternal life.',
        price: 12.00,
        imageUrl: daffodil,
        quantity: 6
    },
    {
        name: 'Hydrangea',
        description: 'With their lush bushes of flowers, hydrangeas symbolize heartfelt emotions and gratitude.',
        price: 15.00,
        imageUrl: hydrangea,
        quantity: 7
    },
    {
        name: 'Peony',
        description: 'Known for their lush and full-bodied petals, peonies represent romance, prosperity, and bashfulness.',
        price: 22.00,
        imageUrl: peony,
        quantity: 8
    },
    {
        name: 'Carnation',
        description: 'Available in numerous colors, each with a different meaning, carnations generally symbolize love and fascination.',
        price: 9.00,
        imageUrl: carnation,
        quantity: 9
    },
    {
        name: 'Chrysanthemum',
        description: 'Often referred to simply as "mums," these flowers symbolize loyalty and honesty and are used in various cultural contexts.',
        price: 10.00,
        imageUrl: chrysanthemum,
        quantity: 10
    },
    {
        name: 'Blue Orchid',
        description: 'The Blue Orchid is a rare and captivating flower, known for its vibrant blue petals and striking appearance. It symbolizes rarity, beauty, and strength, making it perfect for special occasions or as a standout addition to any bouquet.',
        price: 25.00,
        imageUrl: blue_orchid,
        quantity: 15
    },
    {
        name: 'Lavender',
        description: 'Lavender Delight is an elegant arrangement that combines the soothing hues and scents of lavender with complementary foliage. Known for its calming properties, lavender is perfect for creating a serene home environment or for giving as a thoughtful gift to promote relaxation.',
        price: 22.00,
        imageUrl: lavender,
        quantity: 10
    }
];

export default flowers;